import { createContext, useContext, type ReactNode } from 'react';
import type { PanelKonfig } from './konfig.ts';

/**
 * Konfigen til komponentene som trenger den.
 *
 * Den bor IKKE i `konfig.ts`: den filen importeres av `vite.config.ts` og kjører i Node
 * ved bygg, uten React. Blandes de, drar bygget inn React-runtime for å lese en
 * miljøvariabel.
 *
 * Samme mønster som `ApiKlientProvider`. Kaster utenfor provideren — en komponent som
 * leser konfig uten å stå i treet er en feil, ikke en tom verdi.
 */
const Kontekst = createContext<PanelKonfig | null>(null);

export function KonfigProvider({ verdi, children }: { verdi: PanelKonfig; children: ReactNode }) {
  return <Kontekst.Provider value={verdi}>{children}</Kontekst.Provider>;
}

export function useKonfig(): PanelKonfig {
  const v = useContext(Kontekst);
  if (!v) throw new Error('[innspel] useKonfig må stå inne i <KonfigProvider>.');
  return v;
}
